export const CONTRACT_TYPES = Object.freeze({
  PURCHASE: 1,
  SALE: 2,
  CUSTODY: 3,
});
